import React from "react";
import { Form } from "react-bootstrap";
import { PresetObj } from "../../../../../api-entities/PresetArea";
import { AreaOption } from "../../../../../decoders/AreaOption";
import { Area } from "../../../../../entities/Area";
import AreasSelector from "../../../AreasSelector";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: AreaOption;
  presetAreas: Array<PresetObj>;
  userPresetAreas: Array<PresetObj>;
  onChange: (areas: Array<Area>) => void;
}

const AreasField = (props: Props) => {
  const { formik, spec, presetAreas, userPresetAreas, onChange } = props;

  return (
    <Form.Group controlId="areas">
      <Form.Label>Areas</Form.Label>

      <AreasSelector
        values={formik.values.areas}
        grids={formik.values.grid}
        presetAreas={presetAreas}
        userPresetAreas={userPresetAreas}
        onChange={onChange}
      />

      <FormError
        message={formik.errors.areas as TFormErrorMessage}
        when={formik.touched.areas && Boolean(formik.errors.areas)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default AreasField;
